/**
 * exportCsv
 * Minimal client-side CSV export. No dependencies.
 *
 * RFC 4180 escaping: fields that contain commas, quotes, or line breaks
 * are double-quoted; embedded quotes are doubled.
 *
 * UTF-8 BOM is prepended so Excel interprets non-ASCII characters (e.g.
 * "RM", "Ringgit") correctly.
 */

function escapeCell(value) {
  if (value === null || value === undefined) return '';
  const str = String(value);
  if (/[",\r\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

/**
 * @param {Array<object>} rows — data rows
 * @param {Array<{ header: string, accessor: (row) => any }>} columns
 * @param {string} filename — including .csv extension
 */
export function exportRowsToCsv(rows, columns, filename) {
  const header = columns.map(c => escapeCell(c.header)).join(',');
  const body = rows
    .map(row => columns.map(c => escapeCell(c.accessor(row))).join(','))
    .join('\r\n');

  const csv = `${header}\r\n${body}`;
  const blob = new Blob(['﻿', csv], { type: 'text/csv;charset=utf-8;' });

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export default exportRowsToCsv;
